import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBRow, MDBCol,MDBTableBody,MDBTable, MDBTableHead,MDBIcon ,MDBAlert } from 'mdbreact';
import Axios from 'axios'
import { api, URL } from '../../api';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import Modaladdplanshort from './Modaladdplanshort';
import Modaladdteachershort from './Modaladdteachershort';
import Modelshowstudentshort from '../teacher/Modelshowstudentshort';
import Modelresultsstudentshort from '../teacher/Modelresultsstudentshort';




export default class Modelresultsshort extends Component {
    constructor(props) {
              super(props);
      this.state = {
        modal: false,
        studentsearch:[],
        name:'',
        lname:'',
        datedb:'',
        Citizen_ID:'',

        Course_ID:'',
        nameshortterm:'',
        nameshorttermen:'',
        Credit:'',
        team:'',
        numch:'',
        numregis:'',
        TIMESTART:'',
        TIMEEND:'',
        UserUPDATE:'',
        Univ_ID:'1',
        Univ_NAME:'',
        Course_YEAR:'',
        Status_ONOFF:'1',
        Course_Name_TH:'',

       
        Shortcourse_ID:'',
        Shortcoursemd_Course_ID:'',
        Shortcoursemd_Nameshort_TH:'',
        Shortcoursemd_Nameshort_EN:'',
        Shortcoursemd_Numch:'',
        Shortcoursemd_Numregis:'',
        Shortcoursemd_Timestart:'',
        Shortcoursemd_Timeend:'',
        Shortcoursemd_Userupdate:'',
        Shortcoursemd_Status_ONOFF:'1',
        Shortcoursemd_Univ_id:'1',

        Course:[],
        Course_ID:'',
        Shortcourse_Team:'',
         Approve:'1',

         Shortcourse_typegrade:'',

      }
          //this.handleChange = this.handleChange.bind(this);
          this.getstudent = this.getstudent.bind(this);
          this.handleChangename = this.handleChangename.bind(this);
          this.handleChangelname = this.handleChangelname.bind(this);
          this.handleChangedatedb = this.handleChangedatedb.bind(this);
          this.updatestudent = this.updatestudent.bind(this);

          this.handleChangenameshortterm = this.handleChangenameshortterm.bind(this);
          this.handleChangenameshorttermen = this.handleChangenameshorttermen.bind(this);
          this.handleChangteam = this.handleChangteam.bind(this);
          this.handleChangeCredit = this.handleChangeCredit.bind(this);
          this.handleChangech = this.handleChangech.bind(this);
          this.handleChangeregis = this.handleChangeregis.bind(this);
          this.handleChangeTIMESTART = this.handleChangeTIMESTART.bind(this);
          this.handleChangeEND = this.handleChangeEND.bind(this);
          this.updateApprove = this.updateApprove.bind(this);
          this.showshortcoursemd = this.showshortcoursemd.bind(this);
          this.linkto = this.linkto.bind(this);
          
    }


  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
    //this.getstudent()
   // this.props.getShortcourse()
  }

  handleChangename(event) {    this.setState({name: event.target.value});  }
  handleChangelname(event) {    this.setState({lname: event.target.value});  }
  handleChangedatedb(event) {    this.setState({datedb: event.target.value});  }
  handleChangenameshortterm(event) {    this.setState({Shortcoursemd_Nameshort_TH: event.target.value});  }
  handleChangenameshorttermen(event) {    this.setState({Shortcoursemd_Nameshort_EN: event.target.value});  }
  handleChangteam(event) {    this.setState({team: event.target.value});  }
  handleChangeCredit(event) {    this.setState({Credit: event.target.value});  }
  handleChangech(event) {    this.setState({Shortcoursemd_Numch: event.target.value});  }
  handleChangeregis(event) {    this.setState({Shortcoursemd_Numregis: event.target.value});  }
  handleChangeTIMESTART(event) {    this.setState({Shortcoursemd_Timestart: event.target.value});  }
  handleChangeEND(event) {    this.setState({Shortcoursemd_Timeend: event.target.value});  }
  

  getstudent() {
    api.get('index/studentsearch/'+this.props.Studentcb_Citizen_ID,
           //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
        {headers: {
           // Authorization: 'Bearer ' + localStorage.getItem('myData')
        }
        })
           //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
        .then(res => {
           //    console.log(res.data[0].id)
            console.log(res.data[0].Studentcb_NAME)
           //   console.log(ppp)
           //  const student = res.data.filter( ({ citizen_id }) => citizen_id.substring(0, 7) === this.state.major );
            const studentsearch = res.data;
              this.setState({ studentsearch });
              this.setState({   name:res.data[0].Studentcb_NAME,
                                lname:res.data[0].Studentcb_LASTNAME,
                                datedb:res.data[0].Studentcb_DB,
                                Citizen_ID:res.data[0].Studentcb_Citizen_ID
                         });
        })
  }




  updatestudent() {
                setTimeout(() => {

                    const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                    datafrm.append("Shortcourse_ID", this.state.Shortcourse_ID);
                    datafrm.append("Shortcoursemd_Course_ID", this.state.Shortcoursemd_Course_ID);
                    datafrm.append("Shortcoursemd_Nameshort_TH", this.state.Shortcoursemd_Nameshort_TH);
                    datafrm.append("Shortcoursemd_Nameshort_EN", this.state.Shortcoursemd_Nameshort_EN);
                    datafrm.append("Shortcoursemd_Numch", this.state.Shortcoursemd_Numch);
                    datafrm.append("Shortcoursemd_Numregis", this.state.Shortcoursemd_Numregis);
                    datafrm.append("Shortcoursemd_Timestart", this.state.Shortcoursemd_Timestart);
                    datafrm.append("Shortcoursemd_Timeend", this.state.Shortcoursemd_Timeend);
                    datafrm.append("Shortcoursemd_Userupdate", this.state.Shortcoursemd_Userupdate);
                    datafrm.append("Shortcoursemd_Status_ONOFF", this.state.Shortcoursemd_Status_ONOFF);
                    datafrm.append("Shortcoursemd_Univ_id", this.state.Shortcoursemd_Univ_id);
                  
                    
                Axios.post("https://mua.kpru.ac.th/FrontEnd_creditbank/index/AddShortcoursemodule/",datafrm,{
                headers: {
                    'content-type': 'multipart/form-data'
                }
                })
                .then(res => {
                    if (res.status === 200) {
                    //  alert("บันทึกสำเร็จ")
                                Swal.fire({
                                    title: 'บันทึกข้อมูลสำเร็จ',
                                    icon: 'success',
                                    confirmButtonText: 'ตกลง',
                                }).then((result) => {
                                 this.toggle()
                               //  this.getstudent()
                             //  this.props.getShortcourse()
                                })
                            }
                    })
                }, 2000);
  }

  linkto = (event,event2) => {
          console.log(event)
           console.log(event2)
          // console.log(event2.target.value)
          const id = event;
          const id2 = event2;

          window.location.href = '/creditbank/Teachercuriculumshort/'+id+'/'+id2;
         
      }



  componentDidMount(){
    this.setState({ Course_ID:this.props.Course_ID})
    this.setState({ Shortcourse_ID:this.props.Shortcourse_ID})
    this.setState({ Shortcoursemd_Course_ID:this.props.Course_ID})
   // this.setState({ Shortcoursemd_Nameshort_TH:this.props.Course_Name_TH})
  //  this.setState({ Shortcoursemd_Nameshort_EN:this.props.Course_Name_En})
    this.setState({ Credit:this.props.Course_Credit})
   // this.setState({ Shortcoursemd_Numch:this.props.Course_Credit*15})
    this.setState({ Univ_ID:localStorage.getItem('Univ_ID')})
    this.setState({ Univ_NAME:localStorage.getItem('Univ_NAME')})
    this.setState({ Shortcoursemd_Userupdate:localStorage.getItem('Citizen_ID')})
    this.setState({ Course_YEAR:this.props.Shortcourse_Course_YEAR})
      this.setState({ Shortcourse_Team:this.props.Shortcourse_Team})
       this.setState({ Shortcourse_typegrade:this.props.Shortcourse_typegrade})

   // this.setState({ Credit:this.props.Credit})
setTimeout(() => {
    
api.get('index/showshortcoursemd/'+this.props.Course_ID,
        //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
          //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                  {headers: {
                  // Authorization: 'Bearer ' + localStorage.getItem('myData')
                  }
                  })
                  //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                  .then(res => {
                  // console.log(res.data[0].id)
                  //  console.log(res.data)
                //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                  //  console.log(Course)
                     const Course = res.data;
                      this.setState({ Course });
           }) 

}, 500);
        
  }

  showshortcoursemd(){
    setTimeout(() => {
    
api.get('index/showshortcoursemd/'+this.props.Course_ID,
        //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
          //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                  {headers: {
                  // Authorization: 'Bearer ' + localStorage.getItem('myData')
                  }
                  })
                  //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                  .then(res => {
                  // console.log(res.data[0].id)
                  //  console.log(res.data)
                //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                  //  console.log(Course)
                     const Course = res.data;
                      this.setState({ Course });
           }) 

}, 500);
  }


       updateApprove(e) {
        // alert('A name was submitted: ' + this.state.value);
      //  console.log(e.target.value)
        const id = e.target.value;
       setTimeout(() => {
    
          const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
          datafrm.append("Shortcoursemd_ID", id);
          datafrm.append("Approve", this.state.Approve);
        
          
          api.post("index/updateApproveshort/",datafrm,{
            headers: {
                'content-type': 'multipart/form-data'
            }
          })
    
          .then(res => {
        //    console.log(res);
            if (res.status === 200) {
            //  alert("บันทึกสำเร็จ")
                      Swal.fire({
                          title: 'ยื่นพิจารณาสำเร็จ',
                          icon: 'success',
                        // showCancelButton: true,
                          confirmButtonText: 'ตกลง',
                        // cancelButtonText: 'No, keep it'
                        }).then((result) => {
                        
                        })
                     }
            })
          //  this.toggle()
          //  this.props.getclassroom()
          this.showshortcoursemd();
     }, 1000);

      }

  

    render() {



     
        return (
            <div>
                 
                 <MDBContainer>
                   {/* <div className='text-right'><MDBBtn onClick={this.toggle} color="mdb-color" size='sm' >+ เพิ่มหลักสูตรระยะสั้น</MDBBtn></div>   */}

                    
                    <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
                        <MDBModalHeader toggle={this.toggle}>เพิ่มหลักสูตรระยะสั้น/การอบรม</MDBModalHeader>
                        <MDBModalBody>
                       
                                <MDBRow>
                                <MDBCol sm="12">
                                <div className="form-group">
                                    <label htmlFor="example2">รหัสวิชาหลัก</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.props.Course_ID}  disabled />
                                </div>
                               
                               
                                <div className="form-group">
                                    <label htmlFor="example2">ชื่อหลักสูตรระยะสั้น ภาษาไทย</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Shortcoursemd_Nameshort_TH} onChange={this.handleChangenameshortterm}  />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="example2">ชื่อหลักสูตรระยะสั้น ภาษาอังกฤษ</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Shortcoursemd_Nameshort_EN} onChange={this.handleChangenameshorttermen}  />
                                </div>
                                {/* <div className="form-group">
                                    <label htmlFor="example2">จำนวนหน่วยกิต</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Credit} onChange={this.handleChangeCredit} disabled />
                                </div> */}
                                <div>

                                <div className="form-group">
                                    <label htmlFor="example2">จำนวนชั่วโมง</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Shortcoursemd_Numch} onChange={this.handleChangech}  />
                                </div>    

                            
                                </div>
                               
                               
                                <div className="form-group">
                                    <label htmlFor="example2">จำนวนที่รับ</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Shortcoursemd_Numregis} onChange={this.handleChangeregis} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="example2">วันที่ เปิดการสอน</label>
                                    <input type="date" id="example2" className="form-control form-control-md" onChange={this.handleChangeTIMESTART} required/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="example2">วันที่ ปิดการสอน</label>
                                    <input type="date" id="example2" className="form-control form-control-md"  onChange={this.handleChangeEND} required/>
                                </div>
                                {/* <div className="form-group">
                                    <label htmlFor="example2">มหาวิทยาลัย</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Univ_NAME} disabled />
                                </div> */}
                                </MDBCol>
                                </MDBRow>

                        </MDBModalBody>
                        <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                        <MDBBtn color="primary" onClick={this.updatestudent}>บันทึก</MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>


                      <MDBContainer>
                                                <h5 className="display-5 left-center">ตารางหลักสูตรระยะสั้น </h5>
                                                <MDBTable small responsiveMd>
                                                    <MDBTableHead  color="grey darken-1" textWhite>
                                                        <tr>
                                                        <th>#</th>
                                                        <th>ชื่อหลักสูตรระยะสั้น</th>
                                                        <th>จำนวนชั่วโมง</th>
                                                        <th>วันที่เริ่ม</th>
                                                        <th>วันที่สิ้นสุด</th>
                                                        <th>วันที่เพิ่มข้อมูล</th>
                                                        <th>ผลการเรียน</th>
                                                         {/* <th>ลงทะเบียน</th> */}
                                                          {/* <th>หลักสูตร</th> */}
                                                           {/* <th>คณบดี</th> */}
                                                        </tr>
                                                    </MDBTableHead>
                    
                                                    <MDBTableBody>
                                                    {this.state.Course.map((Course,index) => {
                                                      return  <tr>
                                                        <td>{index+1}</td>
                                                        <td>{Course.Shortcoursemd_Nameshort_TH}</td>
                                                        <td>{Course.Shortcoursemd_Numch}</td>
                                                        <td>{Course.Shortcoursemd_Timestart}</td>
                                                        <td>{Course.Shortcoursemd_Timeend}</td>
                                                        <td>{Course.Shortcoursemd_Dateadd}</td>
                                                        <td> 
                                                          {Course.Shortcoursemd_Approve_Cu === "2" ?<>
                                                           <Modelresultsstudentshort Shortcoursemd_ID={Course.Shortcoursemd_ID}  Shortcourse_ID={Course.Shortcourse_ID} Shortcoursemd_Status_grade={Course.Shortcoursemd_Status_grade} Shortcoursemd_Nameshort_TH={Course.Shortcoursemd_Nameshort_TH} Shortcourse_typegrade={this.state.Shortcourse_typegrade}/>
                                                          </>:<>
                                                          อยู่ระหว่างพิจารณา</>}
                                                           
                                                          {/* <Modelshowstudentshort Shortcoursemd_ID={Course.Shortcoursemd_ID} Shortcoursemd_Nameshort_TH={Course.Shortcoursemd_Nameshort_TH} /> */}
                                                          {/* <Modaladdplanshort Shortcourse_Team={this.state.Shortcourse_Team} Course_ID={this.props.Course_ID} Shortcourse_ID={Course.Shortcourse_ID}	Shortcoursemd_ID={Course.Shortcoursemd_ID} Course_YEAR={this.props.Shortcourse_Course_YEAR}	 Shortcourse_Nameshortterm_TH={this.props.Shortcourse_Nameshortterm_TH} Shortcoursemd_Nameshort_TH={Course.Shortcoursemd_Nameshort_TH}/>
                                                             <Modaladdteachershort Shortcourse_Nameshortterm_TH={this.props.Shortcourse_Nameshortterm_TH} Shortcoursemd_Nameshort_TH={Course.Shortcoursemd_Nameshort_TH} Shortcourse_ID={Course.Shortcourse_ID}	Shortcoursemd_ID={Course.Shortcoursemd_ID}/> */}
                                                        </td>
                                                         {/* <td>
                                                         
                                                          <MDBBtn  onClick={() => this.linkto(Course.Shortcoursemd_ID,Course.Shortcourse_ID)} size='sm'>ลงทะเบียนผู้เรียน</MDBBtn>
                                                          
                                                         </td> */}
                                                         {/* <td>
                                                           {Course.Shortcoursemd_Approve_Cu === '1' ? <><MDBIcon icon="sync-alt" /> อยู่ระหว่างพิจารณา</>:<></>}
                                                           {Course.Shortcoursemd_Approve_Cu === '2' ? <><MDBIcon icon="check"  className="green-text pr-3" />อนุมัติ</>:<></>}
                                                           {Course.Shortcoursemd_Approve_Cu === '3' ? <><MDBAlert color="danger " > หลักสูตรไม่อนุมัติ </MDBAlert><MDBAlert color="primary  " > ข้อเสนอแนะ : {Course.Shortcoursemd_Approve_Cu}</MDBAlert><MDBBtn color="amber" size="sm"  value={Course.Shortcoursemd_ID}  onClick={this.updateApprove}>ยื่นพิจารณาอีกครั้ง</MDBBtn></>:<></>}
                                                         </td> */}
                                                         {/* <td>
                                                            {Course.Shortcoursemd_Approve_Dean === null   &&  Course.Shortcoursemd_Approve_Cu === '2'  ? <><MDBIcon icon="sync-alt" /> อยู่ระหว่างพิจารณา</>:<></>}
                                                                                                {Course.Shortcoursemd_Approve_Dean === '2' &&  Course.Shortcoursemd_Approve_Cu === '2'  ? <><MDBIcon icon="check"  className="green-text pr-3" />อนุมัติ</>:<></>}
                                                                                                {Course.Shortcoursemd_Approve_Dean === '3' && Course.Shortcoursemd_Approve_Cu === '2' ? <><MDBAlert color="danger " > คณบดีไม่อนุมัติ </MDBAlert><MDBAlert color="primary  " > ข้อเสนอแนะ : {Course.Shortcoursemd_comment_Dean}</MDBAlert><MDBBtn color="amber" size="sm"  value={Course.Shortcoursemd_ID}  onClick={this.updateApprove}>ยื่นพิจารณาอีกครั้ง</MDBBtn></>:<></>}
                                                                                                {Course.Shortcoursemd_Approve_Dean === '3' &&  Course.Shortcoursemd_Approve_Cu === '1'  ? <><MDBIcon icon="sync-alt" /> อยู่ระหว่างพิจารณา</>:<></>}
                                                         </td> */}
                                                        </tr>
                                                       })}  
                                                    </MDBTableBody>
                                                </MDBTable>   
                    
                                                </MDBContainer>
                 </MDBContainer>
            </div>
        )
    }
}
